import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Label from "../Label/Label";
import styles from "./Select.module.scss";
import CreatableSelect from "react-select/creatable";

const Select = ({
  id,
  label,
  isRequired,
  description,
  placeholder,
  onChange = () => {},
  errors,
  defaultValue,
}) => {
  const [inputValue, setInputValue] = useState("");
  const createOption = (label) => ({
    label,
    value: label,
  });

  const [value, setValue] = useState((defaultValue || []).map(createOption));

  const isInvalid = errors[id] ? "is-invalid" : "";

  const customStyles = {
    control: () => ({
      ...styles.field,
      ...styles.select,
    }),
  };

  const components = {
    DropdownIndicator: null,
    ClearIndicator: null,
  };

  const handleChange = (value) => {
    setValue(value);
  };

  const handleInputChange = (inputValue) => {
    setInputValue(inputValue);
  };

  const addItem = () => {
    if (!inputValue) return;
    setInputValue("");
    setValue([...value, createOption(inputValue)]);
  };

  const handleKeyDown = (event) => {
    switch (event.key) {
      case "Enter":
      case "Tab":
        addItem();
        event.preventDefault();
        break;
      default:
        break;
    }
  };

  const handleBlur = () => {
    addItem();
  };

  //this is passed to the controller
  useEffect(() => onChange(value.map(({ value }) => value)), [value]);

  return (
    <div className={styles.Select} data-testid="Select">
      <Label id={id} label={label} isRequired={isRequired} />
      <span className={`d-block ${styles.description}`}>{description}</span>
      <div className="row no-gutters">
        <div className="col">
          <CreatableSelect
            styles={customStyles}
            className={`${styles.field} ${styles.select} form-control ${isInvalid} h-auto`}
            components={components}
            inputValue={inputValue}
            isMulti
            menuIsOpen={false}
            onChange={handleChange}
            onInputChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            placeholder={placeholder}
            value={value}
          />
        </div>
      </div>
    </div>
  );
};

Select.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  errors: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string,
  }),
  defaultValue: PropTypes.array,
};

Select.defaultProps = {
  id: "",
  label: "",
  isRequired: true,
  description: "",
  placeholder: "",
  onChange: () => {},
  errors: {},
  defaultValue: [],
};

export default Select;
